import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getMyNotifications } from '../services/api';

function Badge({ count }) {
  if (!count) return null;
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        minWidth: 20, height: 20, padding: '0 6px', marginLeft: 8,
        background: 'var(--color-gold)', color: 'var(--color-black)',
        borderRadius: 100, fontSize: '0.72rem', fontWeight: 700,
      }}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}

const LINKS = [
  { to: '/member/dashboard', label: 'Dashboard', key: null },
  { to: '/member/membership', label: 'My Membership', key: null },
  { to: '/member/cases', label: 'My Cases', key: 'cases' },
  { to: '/member/documents', label: 'Documents', key: 'documents' },
  { to: '/member/messages', label: 'Messages', key: 'messages' },
  { to: '/member/appointments', label: 'Appointments', key: null },
  { to: '/member/referral', label: 'Referral Programme', key: null },
];

export default function MemberLayout({ title, children }) {
  const [notifications, setNotifications] = useState({ messages: 0, cases: 0, documents: 0 });

  useEffect(() => {
    const load = () => {
      getMyNotifications()
        .then((res) => setNotifications(res.data))
        .catch(() => {});
    };
    load();
    const interval = setInterval(load, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="dashboard-layout">
      <aside className="dashboard-sidebar">
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? 'active' : '')}>
            {l.label}
            {l.key && <Badge count={notifications[l.key]} />}
          </NavLink>
        ))}
      </aside>
      <div className="dashboard-main">
        {title && <h2 style={{ marginBottom: 24 }}>{title}</h2>}
        {children}
      </div>
    </div>
  );
}
